import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CpdEntry } from '../../../model/CpdEntry';
import { revalidationItemTypes } from '../../../model/revalidationItemTypes';
import { RevalidationItemTypeConfig } from '../../../model/RevalidationItemTypeConfig';

@Component({
    selector: 'app-cpd-entry',
    templateUrl: './cpdEntry.component.html',
    styleUrls: ['./cpdEntry.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CpdEntryComponent implements OnInit {

  @Input() cpdEntry!: CpdEntry;
  @Input() typeVisible = true;
  @Input() annotationsVisible = false;

  type: RevalidationItemTypeConfig | undefined;

  ngOnInit() {
    this.type = revalidationItemTypes.filter(t => t.type === this.cpdEntry.type)[0];
  }

}
